<template>
  <transition name="fade">
    <div v-if="props.show" class="select-auto">
      <div
        class="absolute w-screen h-screen bg-black opacity-70 inset-0 z-10"
        @click.stop="onModalToggle"
      />
      <div
        class="absolute inset-0 w-screen h-screen flex items-center justify-center"
      >
        <div
          class="w-screen mx-2 xl:min-w-[600px] max-w-2xl p-4 relative xl:mx-auto my-auto shadow-lg bg-white z-10"
        >
          <div>
            <div class="text-center">
              <h2 class="text-3xl font-bold text-black">Load Design</h2>
              <div class="">
                <div class="block w-full text-left">Design ID</div>
                <input
                  ref="inputRef"
                  v-model="designID"
                  class="block w-full border border-black p-2 select-text"
                  type="text"
                  placeholder="1234"
                  aria-label="Enter the design ID"
                  @keyup.enter="loadDesign(designID)"
                />
              </div>
            </div>
            <div class="my-2">
              <button
                aria-label="Load Design"
                class="block w-full bg-black px-5 py-2 text-white hover:bg-gray-800 rounded-full"
                @click.stop="loadDesign(designID)"
              >
                Load Design
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { SweetAlertIcon } from '~/types/sweetalert'

const { $toast } = useNuxtApp();
const gridStore = useGridStore();
const projectStore = useProjectStore();
const loadingStore = useLoadingStore();
const designID = ref(null);
const inputRef = ref(null);

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
});
watch(
  () => props.show,
  (newValue) => {
    if (newValue) {
      // Modal is now visible, focus the input after DOM update
      nextTick(() => {
        if (inputRef.value) {
          inputRef.value.focus();
          inputRef.value.select(); // Optional: select all text
        }
      });
    }
  },
  { immediate: true }
);
const emit = defineEmits(["modalToggle"]);

const updateDesignID = (newID) => {
  designID.value = newID;
};

const loadDesign = async (designID) => {
  if (!designID) return;

  try {
    loadingStore.setLoading(true);
    const design = await projectStore.load(designID);
    if (!design) throw new Error("Design not found");
    await gridStore.loadDesign(design);
  } catch (e) {
    if (e.message === "Design not found") {
      $toast.fire({
        icon: SweetAlertIcon.WARNING,
        text: "Design not found",
      });
    } else {
      $toast.fire({
        icon: SweetAlertIcon.ERROR,
        text: "Error loading design",
      });
    }
  } finally {
    updateDesignID("");
    onModalToggle();
    loadingStore.setLoading(false);
  }
};

const onModalToggle = () => {
  emit("modalToggle");
};
</script>

<style>
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 300ms ease-out;
}
</style>
